module.exports = {"wink":"😉","hug":"🤗","speaking-head":"🗣","keyboard":"⌨️","bulb":"💡","woman-technologist":"👩‍💻"};